module.exports = __webpack_public_path__ + "img/goal4.461376d4.png";